import { Routes } from '@angular/router';
import { PageResolver } from './services/resolver.service';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/de/start',
        pathMatch: 'full',
    },
    {
        path: 'hof',
        redirectTo: '/de/hof/home',
        pathMatch: 'full',
    },
    {
        path: 'apartment',
        redirectTo: '/de/apartment/home',
        pathMatch: 'full',
    },
    {
        path: 'hof/:slug/:secondarySlug',
        redirectTo: (route) =>
            `/de/hof/${route.params['slug']}/${route.params['secondarySlug']}`,
        pathMatch: 'full',
    },
    {
        path: 'hof/:slug',
        redirectTo: (route) => `/de/hof/${route.params['slug']}`,
        pathMatch: 'full',
    },
    {
        path: 'apartment/:slug',
        redirectTo: (route) => `/de/apartment/${route.params['slug']}`,
        pathMatch: 'full',
    },
    {
        path: ':languageCode/apartment',
        redirectTo: (route) => {
            const languageCode = route.params['languageCode'];
            if (languageCode === 'de' || languageCode === 'en') {
                return `${route.params['languageCode']}/apartment/home`;
            }
            return `de/apartment/home`;
        },
        pathMatch: 'full',
    },
    {
        path: ':languageCode/hof',
        redirectTo: (route) => {
            const languageCode = route.params['languageCode'];
            if (languageCode === 'de' || languageCode === 'en') {
                return `${route.params['languageCode']}/hof/home`;
            }
            return `de/hof/home`;
        },
        pathMatch: 'full',
    },
    {
        path: ':languageCode/:slug',
        loadComponent: () =>
            import('./renderer/start/start-renderer.component').then(
                (m) => m.StartRendererComponent,
            ),
        resolve: {
            page: PageResolver,
        },
    },
    {
        path: ':languageCode/apartment/:slug',
        loadChildren: () =>
            import('./routes/apartment.routes').then((m) => m.APARTMENT_ROUTES),
    },
    {
        path: ':languageCode/hof/:slug',
        loadChildren: () =>
            import('./routes/hof.routes').then((m) => m.HOF_ROUTES),
    },
    {
        path: ':languageCode/hof/:slug/:productSlug',
        loadChildren: () =>
            import('./routes/hof-product.routes').then(
                (m) => m.HOF_PRODUCT_ROUTES,
            ),
    },
    {
        matcher: (segments) =>
            segments.length === 1 && /^[a-z]{2}$/.test(segments[0].path)
                ? { consumed: segments, posParams: { languageCode: segments[0] } }
                : null,
        redirectTo: (route) => {
            const languageCode = route.params['languageCode'];
            if (languageCode === 'de' || languageCode === 'en') {
                return `${route.params['languageCode']}/start`;
            }
            return `de/start`;
        },
        pathMatch: 'full',
    },
    {
        path: '**',
        loadComponent: () =>
            import('./components/common/not-found/not-found.component').then(
                (m) => m.NotFoundComponent,
            ),
    },
];
